// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import SearchBar from './search/SearchBarComponent';
import BulkActionsBar from './bulk-actions/BulkActionsBarComponent';
import FilterBar from './filter/FilterBarComponent';

import { getProductRouteById } from '../../services/products-route/ProductsRouteService';
import { envUrl } from '../../services/environment/EnvironmentService';

import './Toolbar.scss';
import AnalyticsClient from '../../../clients/AnalyticsClient';
import productEvents from '../../../analytics/events/products';

/**
 * Displays Toolbar for filtering products
 */

type Props = {
  productTypeId: string,
  searchTerm?: string,
  isVisible?: boolean,
};

export type Filters = {
  templateFilter: string,
  sortFilter: string,
  sizeFilter: string,
  templateValue: string,
};

class ToolbarComponent extends React.Component {
  constructor(props: Props): void {
    super(props);
    this.state = {
      isFilterVisible: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.productTypeId !== prevProps.productTypeId) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isFilterVisible: false,
      });
    }
  }

  updateProductSelectionFilters(updatedFilters: Filters): void {
    const filterString = `?template=${updatedFilters.templateFilter}&productSize=${updatedFilters.sizeFilter}&productSort=${updatedFilters.sortFilter}&searchTerm=${this.props.searchTerm}`;
    const route = getProductRouteById(this.props.productTypeId);

    this.props.history.push({
      pathname: envUrl(`/products/${route}`),
      search: filterString,
    });
  }

  openFilter = (): void => {
    this.setState({
      isFilterVisible: true,
    });
  };

  closeFilter = (updatedFilters: Filters): void => {
    if (updatedFilters !== null) {
      this.updateProductSelectionFilters(updatedFilters);
      AnalyticsClient.trackEvent(productEvents.filterProducts(updatedFilters));
    }
    this.setState({
      isFilterVisible: false,
    });
  };

  render(): Element {
    const showToolbar = this.props.isVisible ? '' : 'toolbar-component__container--hide';
    const hasBulkSelection = this.props.permissions.includes('bulkSelectProducts');

    return (
      <div className={`toolbar-component__container ${showToolbar}`}>
        <div className="toolbar-component">
          <SearchBar {...this.props} onOpenFilters={this.openFilter} hasBulkSelection={hasBulkSelection} />

          <FilterBar {...this.props} isVisible={this.state.isFilterVisible} onCloseFilters={this.closeFilter} />

          <BulkActionsBar {...this.props} />
        </div>
      </div>
    );
  }
}

ToolbarComponent.displayName = 'Toolbar';

ToolbarComponent.propTypes = {
  productTypeId: PropTypes.string,
  searchTerm: PropTypes.string,
  isVisible: PropTypes.bool,
};

ToolbarComponent.defaultProps = {
  searchTerm: '',
};

export default withRouter(ToolbarComponent);
